/**
 * Format a retention period (stored in months) as a German human-readable string
 * preferring years over months when possible.
 */
export function formatRetention(months: number | null | undefined): string {
  if (months == null) return '-';
  if (months === 0) return '0 Monate';
  if (months < 12) {
    return months === 1 ? '1 Monat' : `${months} Monate`;
  }
  if (months % 12 === 0) {
    const years = months / 12;
    return years === 1 ? '1 Jahr' : `${years} Jahre`;
  }
  const years = Math.floor(months / 12);
  const rem = months % 12;
  const yearPart = years === 1 ? '1 Jahr' : `${years} Jahre`;
  const monthPart = rem === 1 ? '1 Monat' : `${rem} Monate`;
  return `${yearPart} ${monthPart}`;
}
